<template>
  <div>
    <!-- pc端 -->
    <section class="contrainer1" :style="{background:'rgba(31,42,63,'+opacity+')'}">
      <a href="/" class="logo">
        <img src="@/assets/images/logo_white.png" alt />
      </a>
      <ul class="menu" v-if="token">
        <li v-for="(item,index) in mobileMenuList" :key="index">
          <router-link :to="item.link">{{item.name}}</router-link>
        </li>
         <li class="to-old" @click="handleToOld">
          访问旧版
           <i class="el-icon-link"></i>
          </li>
      </ul>
      <ul class="menu" v-else>
        <li v-for="(item,index) in menuList" :key="index">
          <router-link :to="item.link">{{item.name}}</router-link>
        </li>
         <li class="to-old" @click="handleToOld">
          访问旧版
          <i class="el-icon-link"></i>
          </li>
      </ul>
    </section>
    <!-- 移动端 -->
    <section class="contrainer2 nav-wrap" :style="{background:'rgba(31,42,63,'+opacity+')'}">
      <a href="/" class="logo">
        <img src="@/assets/images/logo_white.png" style="width:100px" alt />
      </a>
      <div>
        <div class="icon-menu">
          <i class="el-icon-menu" @click="showMenu($event)" />
        </div>
        <el-collapse-transition>
          <div v-show="isShow">
            <ul class="menu nav-box transition-box" v-if="token">
              <li v-for="(item,index) in mobileMenuList" :key="index">
                <router-link :to="item.link">{{item.name}}</router-link>
              </li>
              <li @click="handleToOld">
               访问旧版
              </li>
            </ul>
            <ul class="menu nav-box transition-box" v-else>
              <li v-for="(item,index) in menuList" :key="index">
                <router-link :to="item.link">{{item.name}}</router-link>
              </li>
              <li @click="handleToOld">
               访问旧版
              </li>
            </ul>
          </div>
        </el-collapse-transition>
      </div>
    </section>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import router from "../../router";
export default {
  data() {
    return {
      opacity: 0,
      isShow: false,
      isFocus: false
    };
  },
  computed: {
    ...mapGetters(["menuList", "mobileMenuList", "token"])
  },
  mounted() {
    const _this = this;
    if (document.body.clientWidth < 993) {
      this.isShow = false;
      this.isFocus = false;
    } else {
      this.isShow = true;
    }
    document.onclick = function() {
      if (!_this.isFocus) {
        _this.isShow = false;
      }
    };
    window.addEventListener("scroll", e => {
      if (document.documentElement.scrollTop <= 200) {
        this.opacity = (document.documentElement.scrollTop / 200).toFixed(1);
      }
    });
  },
  methods: {
    handleToOld(){
      window.location.href="https://old.zhongcheyun.cn"
    },
    showMenu(event) {
      event.stopPropagation();
      this.isShow = !this.isShow;
    },
    menuToggle() {
      this.isShow = !this.isShow;
    }
  }
};
</script>
<style lang="less" scoped>

.contrainer1 {
  width: 100%;
  height: 70px;
  position: fixed;
  z-index: 9000;
  padding: 0 30px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .menu {
    height: 100%;
    display: flex;
    align-items: center;
    .to-old{
      color: #FFA500;
      cursor: pointer;
      &:hover{
        font-weight: 600;
        color: #FF8C00;
      }
    }
    li {
      height: 100%;
      text-align: center;
      line-height: 70px;
      padding: 0 20px;
      a {
        color: #d0d0d0;
        font-size: 16px;
        font-weight: bold;
        &:hover {
          color: #fff;
        }
      }
    }
  }
  .logo {
    img {
      height: 30px;
    }
  }
}
.contrainer2 {
  display: none;
  .nav-box {
    display: block;
  }
}
@media screen and (max-width: 992px) {
  .contrainer2 {
    height: 60px;
    display: flex;
    width: 100%;
    position: fixed;
    z-index: 9999;
    padding: 0 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: rgba(31, 42, 63, 0.9);
    .logo {
      height: 30px;
      color: #fff;
    }
    .icon-menu {
      display: block;
      float: right;
      font-size: 26px;
      // padding-right: 20px;
      color: #fff;
    }

    .nav-box {
      position: absolute;
      top: 60px;
      left: 0;
      right: 0;
      width: 100%;
      padding: 0;
      text-align: center;
      box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.2);
      border-radius: 0 0 8px 8px;
      background-color: rgba(255, 255, 255, 0.98);
      li {
        border-top: 1px solid #eee;
        color: #101f4a;
        padding: 10px 0;
        font-size: 14px;
        &:hover,
        &.active {
          color: #101f4a;
          font-weight: bold;
        }
      }
    }
  }
  .contrainer1 {
    display: none;
  }
  .account-layout {
    padding-top: 60px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/navbar/index.vue